import { render, staticRenderFns } from "./svgiconcopy.vue?vue&type=template&id=16eaf293&scoped=true"
import script from "./svgiconcopy.vue?vue&type=script&lang=js"
export * from "./svgiconcopy.vue?vue&type=script&lang=js"
import style0 from "./svgiconcopy.vue?vue&type=style&index=0&id=16eaf293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eaf293",
  null
  
)

export default component.exports